import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface GenericSplitScreenConfig {
  showRightSection?: boolean;
  fullScreen?: boolean;
}

@Component({
  selector: 'app-generic-split-screen-modal',
  templateUrl: './generic-split-screen-modal.component.html',
  styleUrls: ['./generic-split-screen-modal.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class GenericSplitScreenModalComponent {
  @Input() config: GenericSplitScreenConfig = {
    showRightSection: true,
    fullScreen: false,
  };

  constructor() {}
}
